import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getTwitchStreams } from '../services/api';

function fmtViewers(n) {
  if (n >= 1000) return (n / 1000).toFixed(1).replace('.', ',') + 'k';
  return String(n);
}

function TopStreams() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('brasil');
  const [streams, setStreams] = useState([]);
  const [configured, setConfigured] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getTwitchStreams(tab)
      .then(data => {
        setStreams(data.streams || []);
        setConfigured(data.configured !== false);
      })
      .catch(() => setStreams([]))
      .finally(() => setLoading(false));
  }, [tab]);

  return (
    <section id="top-streams" className="sidebar-box">
      <div className="box-header streams-header">
        <h3>TOP STREAMS</h3>
        <div className="streams-tabs">
          <button
            className={`stream-tab${tab === 'brasil' ? ' active' : ''}`}
            onClick={() => setTab('brasil')}
          >🇧🇷 Brasil</button>
          <button
            className={`stream-tab${tab === 'mundo' ? ' active' : ''}`}
            onClick={() => setTab('mundo')}
          >🌍 {t('topStreams.world')}</button>
        </div>
      </div>

      {loading && (
        <div className="streams-empty">{t('common.loading')}</div>
      )}

      {!loading && !configured && (
        <div className="streams-empty">{t('topStreams.notConfigured')}</div>
      )}

      {!loading && configured && streams.length === 0 && (
        <div className="streams-empty">{t('topStreams.noStreams')}</div>
      )}

      {!loading && configured && streams.map(s => (
        <a
          key={s.user_login}
          href={`https://twitch.tv/${s.user_login}`}
          target="_blank"
          rel="noopener noreferrer"
          className="stream-item"
        >
          <img
            className="stream-thumb"
            src={s.thumbnail_url}
            alt={s.user_name}
            loading="lazy"
          />
          <div className="stream-info">
            <span className="streamer">{s.user_name}</span>
            <span className="stream-title">{s.title}</span>
            <span className="viewers">
              <span className="live-dot" /> {fmtViewers(s.viewer_count)} {t('topStreams.live')}
            </span>
          </div>
        </a>
      ))}
    </section>
  );
}

export default TopStreams;
